import { isValidEmailAddress, isValidPassword, number_format } from '../functions';

const shoppingCartSidebar = {
    isLoading: false,
    offcanvas: null,
    
    init() {
        this.offcanvas = new bootstrap.Offcanvas('#offcanvasCart');
					
    },
    refresh() {
        var _this = this;

        var values = '_token=' + $("meta[name='csrf-token']").attr("content");
		$.ajax({
            type: "POST",
            url: baseURL + "/cart/sidecart-refresh",
            data: values,
            success: function(response) {

                if (response.status == 1) {

					$('#offcanvas-products-list').html(response.view);
					$('.sidebar-cart-count').text(response.cart_items_count);
					$('.sidebar-cart-total').text(response.data.subtotal + ' LEI');
					$('.sidebar-cart-total-without-vat span').text(number_format(response.data.subtotal_without_vat, 2, '.', ''));
                    _this.show();

                    return false;
                }

				Swal.fire({
					//icon: "success",
					html: response.message
				});
				return false;
            },
            error(error) {

            }
        });
    },
    show() {
        this.offcanvas.show();
    }
}

shoppingCartSidebar.init();

export default shoppingCartSidebar;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/sidebar-cart.js